// NODE IMPORTS
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

// CUSTOM IMPORTS
import useTheme from '../utils/use-theme';
import Layout from '../components/Layout';
import SEO from '../components/Seo';
import FaqCategoryAnswersLanding from '../components/FaqCategoryAnswersLanding';

const FaqCategoryAnswersPage = ({ pageContext, data }) => {
  const { cat_contentful_id, sub_contentful_id, faq_contentful_id } =
    pageContext;
  const { themes, themesToggle } = useTheme();
  const { contentfulPage, allContentfulFaqCategory } = data;
  const {
    metaTitle,
    metaDescription,
    optionalCustomPageHeader,
    customFooter,
    topNotificationBanner,
    sections,
  } = contentfulPage;

  // Target specific category
  const categoryData = allContentfulFaqCategory.nodes.find(
    (c) => c.contentful_id === cat_contentful_id
  );

  // Target specific sub category
  const subCategoryData = categoryData.faqSubCategories.find(
    (s) => s.contentful_id === sub_contentful_id
  );

  // Target specific faq
  const faqData = subCategoryData.faqItems.find(
    (f) => f.contentful_id === faq_contentful_id
  );

  // get faq search section from FAQ page
  const search = sections.find((s) => s.component === 'search-section');

  const pageTitle = JSON.parse(faqData.question.raw).content[0].content[0]
    .value;

  return (
    <Layout
      header={optionalCustomPageHeader}
      topNotificationBanner={topNotificationBanner}
      footer={customFooter}
      themes={themes}
      themesToggle={themesToggle}
    >
      <SEO
        metaTitle={`${pageTitle} - ${categoryData.faqCategoryName} - ${metaTitle}`}
        metaDescription={metaDescription.metaDescription}
      />
      <FaqCategoryAnswersLanding
        data={allContentfulFaqCategory}
        categoryData={categoryData}
        subCategoryData={subCategoryData}
        faqData={faqData}
        search={search}
        themes={themes}
      />
    </Layout>
  );
};

FaqCategoryAnswersPage.propTypes = {
  data: PropTypes.shape().isRequired,
  pageContext: PropTypes.shape().isRequired,
};

// Note: This is using the same page query as the main FAQ page to be able to pull in the header, footer, meta etc without needing a new page in the CMS
export const query = graphql`
  query FaqCategoryAnswersPage($locale: String = "en-CA") {
    contentfulPage(
      contentful_id: { eq: "1Vwe5iJc5T1OKVbf3ylXMw" }
      node_locale: { eq: $locale }
    ) {
      contentful_id
      internalName
      node_locale
      metaTitle
      metaDescription {
        metaDescription
      }
      ...OptionalHeader
      ...OptionalFooter
      ...NotificationBanner
      sections {
        ...SearchSection
      }
    }
    ...AllFaqCategoryQuery
  }
`;

export default FaqCategoryAnswersPage;
